
import React from "react";
import { useState, useEffect } from "react";
import { Button, Input, Select, Tabs, Space, Typography, Row, Col, } from "antd";
import { SearchOutlined, DownloadOutlined } from "@ant-design/icons";
import { getStockDet, getStockItemTypes } from "../../../services/generic";
// import { Row, Col, Select,Card, Spin, Table,Form,Button,Modal,Input,InputNumber,message } from "antd";

const { Option } = Select;
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const StockOverview = ({
  searchQuery,
  setSearchQuery,
  selectedItemType,
  setSelectedItemType,
  selectedLocation,
  setSelectedLocation,
  selectedCategory,
  setSelectedCategory,
}) => {

  const [types, setTypes] = useState();
  const [bunits, setBunits] = useState();
  useEffect(async () => {
    const response = await getStockItemTypes();
    const userData = JSON.parse(localStorage.getItem("userData"))
    const warehouse = await getStockDet(userData.user_id);
    setBunits(warehouse)
    setTypes(response)
    console.log(response)
  }, [])
  return (
    <div>
      <Row justify="space-between" align="middle">
        <Col>
          {/* <Title >Stock Overview</Title> */}
          <Col span={24}>
            <span style={{ fontFamily: "Inter", fontSize: "24px", fontWeight: 600 }}>Stock Overview</span>
          </Col>
          {/* <h2 style={{ fontWeight: "700", fontSize: "16px", color: "rgb(0 0 0 / 65%)", marginBottom: "8px", marginTop: "1%" }}>Stock Receipt</h2> */}

          <Paragraph style={{ marginTop: "-6px", color: "text-gray-600" }} type="primary">Manage and monitor inventory across all locations</Paragraph>
        </Col>
        {/* <Col>
          <Space>
            <Button style={{ borderRadius: "5px" }} icon={<DownloadOutlined />}>Export</Button>
            <Button style={{ borderRadius: "5px" }} type="primary">Bulk Actions</Button>
          </Space>
        </Col> */}
      </Row>

      <Row gutter={16} style={{ marginTop: -8 }}>
        <Col
          xs={24} sm={8} md={8} lg={10}
        >

          <Input
            style={{ borderRadius: "5px" }}
            prefix={<SearchOutlined />}
            placeholder="Search by product name, SKU..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            allowClear
          />
        </Col>
        {/* <Col
          xs={24} sm={12} md={8} lg={4}
        >
          <Select
            value={selectedItemType}
            onChange={setSelectedItemType}
            placeholder="Item Type"
            style={{ width: "100%" }}
          >
            <Option value="all">All Item Types</Option>
            <Option value="Food Service">Food Service</Option>
            <Option value="Ingredients">Ingredients</Option>
            <Option value="Semi-finished">Semi-finished</Option>
            <Option value="Utensils">Utensils</Option>
            <Option value="Packaging">Packaging</Option>
          </Select>
        </Col> */}
        <Col
          xs={24} sm={12} md={8} lg={4}
        >
          <Select
            value={selectedLocation === "all" ? undefined : selectedLocation}
            onChange={setSelectedLocation}
            placeholder="Select Location *"
            style={{ width: "100%" }}
            status={selectedLocation === "all" ? "error" : ""}
          >
            {bunits?.map(res => {
              if (res.warehouse !== null) {
                return (
                  <Option key={res.m_warehouse_id} value={res.m_warehouse_id}>{res.warehouse}</Option>
                )
              }
            })
            }
          </Select>
        </Col>
      </Row>

      <Row style={{ marginTop: 10 }}>
        <Col span={24}>

          <Tabs
            style={{ backgroundColor: 'white' }}
            activeKey={selectedCategory}
            onChange={setSelectedCategory}
          >
            <Tabs.TabPane tab="All Items" key="all" />
            {types?.map(res => {
              return (
                <Tabs.TabPane tab={res.name} key={res.value} />
              )
            })}

          </Tabs>

        </Col>
      </Row>
    </div>

  );
};

export default StockOverview;
